// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5730) return "static/chunks/44530001-122b3085beb7327a.js";
	if (chunkId === 8297) return "static/chunks/8297-0300b9bc737e3fd5.js";
	if (chunkId === 5050) return "static/chunks/5050-ca7301fe55141e29.js";
	if (chunkId === 13) return "static/chunks/13-3f76ef9c5f0c0872.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1989":"c6221d548cd602bd","3358":"8e1bb44b115238b4","4850":"4237bd2deea6fc13","6735":"0ce47407ab2bd45a"}[chunkId] + ".js";
};